import {
    createGroup,
    deleteGroup,
    generateLicenses,
    revokeLicense,
    updateGroupMembers,
    updateGroupParent,
} from "@dashboard/devices/store";
import { filesApi } from "@dashboard/files/api";
import { policiesApi } from "@dashboard/policies/api";
import { productsApi } from "@dashboard/products/api";
import { createProvisioning, deleteProvisioning } from "@dashboard/provisioning/store";
import { fdroidsApi } from "@dashboard/repositories/api";
import { isAnyOf, ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

import { workspacesApi } from ".";

const workspacesActions = isAnyOf(
    updateGroupMembers.fulfilled,
    deleteGroup.fulfilled,
    createGroup.fulfilled,
    updateGroupParent.fulfilled,
    createProvisioning.fulfilled,
    deleteProvisioning.fulfilled,
    generateLicenses.fulfilled,
    revokeLicense.fulfilled,
    policiesApi.endpoints.createPolicy.matchFulfilled,
    policiesApi.endpoints.deletePolicy.matchFulfilled,
    productsApi.endpoints.createProduct.matchFulfilled,
    productsApi.endpoints.deleteProduct.matchFulfilled,
    productsApi.endpoints.createBuild.matchFulfilled,
    productsApi.endpoints.deleteBuild.matchFulfilled,
    productsApi.endpoints.importProductBuild.matchFulfilled,
    fdroidsApi.endpoints.createFdroid.matchFulfilled,
    fdroidsApi.endpoints.deleteFdroid.matchFulfilled,
    filesApi.endpoints.uploadFile.matchFulfilled,
    filesApi.endpoints.deleteFile.matchFulfilled,
);

export const initWorkspacesCacheListener = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        matcher: workspacesActions,
        effect: (action, listenerApi) => {
            const isUploadFileAction = filesApi.endpoints.uploadFile.matchFulfilled(action);
            const isDeleteFileAction = filesApi.endpoints.deleteFile.matchFulfilled(action);
            if (isUploadFileAction || isDeleteFileAction) {
                listenerApi.dispatch(workspacesApi.util.invalidateTags(["WorkspaceFeatures"]));
            } else {
                listenerApi.dispatch(workspacesApi.util.invalidateTags(["Workspaces", "WorkspaceFeatures"]));
            }
        },
    });
};
